import { Route, Routes } from "react-router-dom";
import { Routes as FinanceRoutes } from "./routes";
import { FinanceRouterCmp } from "./types";
import { OfferSearchPage } from "../pages/offers/OfferSearchPage";
import { ContractSearchPage } from "../pages/contracts/ContractSearchPage";
import { InvoiceSearchPage } from "../pages/invoices/InvoiceSearchPage";
import { DocumentSearchPage } from "../pages/documents/DocumentSearchPage";
import { ExpenseSearchPage } from "../pages/expenses/ExpenseSearchPage";


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FinanceRouter: FinanceRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route path={OfferSearchPage.route} element={<OfferSearchPage />} />
        <Route path={ContractSearchPage.route} element={<ContractSearchPage />} />
        <Route path={InvoiceSearchPage.route} element={<InvoiceSearchPage />} />
        <Route path={DocumentSearchPage.route} element={<DocumentSearchPage />} />
        <Route path={ExpenseSearchPage.route} element={<ExpenseSearchPage />} />
      </Routes>
    </>
  );
};

FinanceRouter.route = FinanceRoutes.FinanceRouter;

export default FinanceRouter;
